/**
 * Me-Profile + MFA + Sessions Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/security
 */

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_ME_DB__) {
    window.__ORBIT_ME_DB__ = {
      mfaEnabled: false,
      mfaSecret: null,
      mfaEnabledAt: null,
      passwordChangedAt: new Date(Date.now() - 90 * 86_400_000).toISOString(),
      sessions: [
        {
          id: 's_current',
          current: true,
          createdAt: new Date(Date.now() - 2 * 3_600_000).toISOString(),
          lastActivityAt: new Date(Date.now() - 30_000).toISOString(),
          ip: '203.0.113.42',
          userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Orbit/1.0',
          location: 'München, DE',
        },
        {
          id: 's_mobile',
          current: false,
          createdAt: new Date(Date.now() - 5 * 86_400_000).toISOString(),
          lastActivityAt: new Date(Date.now() - 3 * 3_600_000).toISOString(),
          ip: '203.0.113.99',
          userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0) Safari',
          location: 'Berlin, DE',
        },
        {
          id: 's_old',
          current: false,
          createdAt: new Date(Date.now() - 14 * 86_400_000).toISOString(),
          lastActivityAt: new Date(Date.now() - 12 * 86_400_000).toISOString(),
          ip: '198.51.100.7',
          userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)',
          location: 'Frankfurt, DE',
        },
      ],
    };
  }
  return window.__ORBIT_ME_DB__;
}

export function sessionsFixture() {
  return { sessions: [...persist().sessions] };
}

export function revokeSessionFixture(id) {
  const db = persist();
  const idx = db.sessions.findIndex((s) => s.id === id);
  if (idx >= 0) db.sessions.splice(idx, 1);
  return { ok: true };
}

export function updateProfileFixture(patch) {
  // Mock-Profile-Update — wirkt nicht auf den globalen Me-Store
  return { user: patch };
}

export function changePasswordFixture(_payload) {
  const db = persist();
  db.passwordChangedAt = new Date().toISOString();
  return { ok: true, passwordChangedAt: db.passwordChangedAt };
}

export function mfaStatusFixture() {
  const db = persist();
  return {
    enabled: db.mfaEnabled,
    enabledAt: db.mfaEnabledAt,
    passwordChangedAt: db.passwordChangedAt,
  };
}

export function mfaSetupFixture(email = 'operator@valitype.com') {
  const db = persist();
  const secret = randomBase32(32);
  db.mfaSecret = secret;
  const issuer = 'Orbit · Valitype';
  const account = encodeURIComponent(email);
  const provisioningUrl = `otpauth://totp/${encodeURIComponent(issuer)}:${account}?secret=${secret}&issuer=${encodeURIComponent(issuer)}&algorithm=SHA1&digits=6&period=30`;
  return { secret, provisioningUrl };
}

export function mfaVerifyFixture(code) {
  // Fixture-Mode: jeder Code beginnend mit "1" oder "0" wird als valid akzeptiert
  if (!/^\d{6}$/.test(code)) {
    const err = new Error('Code muss 6 Ziffern haben.');
    err.code = 'mfa_invalid_code';
    err.status = 400;
    throw err;
  }
  const db = persist();
  db.mfaEnabled = true;
  db.mfaEnabledAt = new Date().toISOString();
  return {
    enabled: true,
    enabledAt: db.mfaEnabledAt,
    backupCodes: generateBackupCodes(10),
  };
}

export function mfaDisableFixture(_payload) {
  const db = persist();
  db.mfaEnabled = false;
  db.mfaSecret = null;
  db.mfaEnabledAt = null;
  return { enabled: false };
}

export function mfaRegenerateBackupCodesFixture() {
  return { backupCodes: generateBackupCodes(10) };
}

function randomBase32(len) {
  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
  let s = '';
  for (let i = 0; i < len; i += 1) s += c[Math.floor(Math.random() * c.length)];
  return s;
}

function generateBackupCodes(n) {
  const codes = [];
  for (let i = 0; i < n; i += 1) {
    const a = randomBase32(4).toLowerCase();
    const b = randomBase32(4).toLowerCase();
    codes.push(`${a}-${b}`);
  }
  return codes;
}
